export default "__VITE_ASSET__CSZuxXdy__"